var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"KnColumnLabelsRow contentModule hSpace hSpace--formRow",class:_vm.elmClasses,attrs:{"name":"KnColumnLabelsRow"}},[_c('div',{staticClass:"KnColumnLabelsRow__inner contentModule__inner"},_vm._l((_vm.theItems),function(item,index){return _c('a',{key:index,staticClass:"KnColumnLabelsRow__item",style:({
					'grid-column' : 'span ' + item.span,
				}),domProps:{"innerHTML":_vm._s(item.label)}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }